module.exports = "/_next/static/images/LovedBy10MillionDevelopers-53332698b1d5aa28a021bbb2ef782b36.webp";